import forDevice from '../../hoc/for-device';

import SelectMobile from './select-mobile';
import SelectDesktop from './select-desktop';

export default forDevice(SelectMobile, SelectDesktop);



// WEBPACK FOOTER //
// ./app/components/select/index.js